// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQ_wrapper__WLBP4","qa_item":"FAQ_qa_item__GsQBF","answer":"FAQ_answer__vrmXT"};